<template>
    <div class="content-heading">
        <i class="ic-head-icon">
            <img src="@/assets/images/sidebar/booking.svg" alt="Booking Icon">
        </i>
        <h4 class="head-title">Booking</h4>
        <i class="ic-tooltip" id="help"></i>
        <b-popover target="help"
                triggers="hover"
                content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
        </b-popover>
        <div class="head-tabs">
            <b-nav tabs>
                <b-nav-item v-if="permission.isTopUpEnable('booking') && permission.hasAccess('booking:topup.class:topup-booking')" :to="{ path: '/booking/class'}">
                    Class
                </b-nav-item>
                <b-nav-item v-if="permission.isTopUpEnable('booking') && permission.hasAccess('booking:topup.instructor:topup-booking')" :to="{ path: '/booking/instructor' }">
                    Instructor
                </b-nav-item>
                <b-nav-item v-if="permission.isTopUpEnable('booking') && permission.hasAccess('booking:topup.scheduler:topup-booking')" :to="{ path: '/booking/scheduler' }">
                    Scheduler
                </b-nav-item>
                <b-nav-item v-if="permission.isTopUpEnable('booking') && permission.hasAccess('booking:topup.package:topup-booking')" :to="{ path: '/booking/package' }">
                    Package
                </b-nav-item>
                <b-nav-item v-if="permission.isTopUpEnable('booking') && permission.hasAccess('booking:topup.settings:topup-booking')" :to="{ path: '/booking/settings' }">
                    Settings
                </b-nav-item>
            </b-nav>
        </div>
    </div>
</template>

<script>
import permission from "../../services/user.permission";
export default {
    name: "booking-nav",
    data() {
        return {
            msg: "Booking Nav",
            permission: permission
        };
    }
};
</script>

<style scoped>
</style>
